import { Component, inject } from "@angular/core";
import { RewardMechanismTouchDeviceNotice } from "@components/reward-mechanism-touch-device-notice/reward-mechanism-touch-device-notice";
import {
  RdxDialogCloseDirective,
  RdxDialogContentDirective,
  RdxDialogTitleDirective,
  RdxDialogDescriptionDirective,
} from "@radix-ng/primitives/dialog";
import { RewardService } from "@services/reward.service";

@Component({
  selector: "app-reward-cursor-indications-modal",
  imports: [
    RdxDialogCloseDirective,
    RdxDialogContentDirective,
    RdxDialogTitleDirective,
    RewardMechanismTouchDeviceNotice,
    RdxDialogDescriptionDirective,
  ],
  template: `
    <div class="modal modal-large reward-cursor-indications-modal" data-testid="reward-cursor-indications-modal" rdxDialogContent>
      <div class="modal-content">
        <h2 class="modal__title title-h4" rdxDialogTitle>
          Entraine-toi<br />
          pour débloquer de nouveaux curseurs!
        </h2>
        <p class="modal__subtitle body-2" data-testid="reward-cursor-indications-modal-subtitle" rdxDialogDescription>
          Récolte un nouveau curseur après <strong class="bold">24 exercices réussis</strong>.
        </p>
        <div class="modal__cursors">
          @for (cursor of cursors; track cursor) {
            <div class="modal__cursor cursor-and-arrow" [attr.data-testid]="'cursor-' + cursor">
              <img class="cursor__arrow" src="assets/cursors/cursor-arrow.svg" alt="Cursor Arrow" />
              <img [class]="'cursor__image cursor--' + cursor" [src]="'assets/cursors/' + cursor + '.svg'" [alt]="'Reward Cursor ' + cursor" />
            </div>
          }
        </div>
      </div>
      <app-reward-mecanism-touch-device-notice />
      <div class="modal-actions">
        <button type="button" class="btn btn-primary modal-action" (click)="handleAcknowledgedRewardCursor()" rdxDialogClose>J'ai compris!</button>
      </div>
    </div>
  `,
  styles: `
    @use "responsive" as *;

    .reward-cursor-indications-dialog {
      width: 100%;
      padding: 0;
    }

    .modal__title {
      text-align: center;

      @include screenWidth("from-tablet") {
        margin-bottom: 8px;
      }
    }

    .modal__subtitle {
      text-align: center;
      margin-bottom: 24px;

      @include screenWidth("from-tablet") {
        margin-bottom: 32px;
      }
    }

    .modal__cursors {
      display: flex;
      justify-content: center;
      gap: 4px;
      padding-top: 18px;
      padding-bottom: 2px;
      width: 100%;
      border-radius: 20px;
      border: 2px solid #e7e1d8;
      background: #f4fbfe;
      overflow-x: hidden;

      @include screenWidth("from-tablet") {
        gap: 8px;
        padding-top: 42px;
        padding-bottom: 4px;
      }
    }

    .modal__cursor {
      display: block;
      flex-shrink: 0;
    }
  `,
})
export class RewardCursorIndicationsModal {
  private rewardService = inject(RewardService);
  protected cursors = ["turtle", "bee", "dino", "bird", "unicorn", "chicken", "frog", "fish"];

  protected handleAcknowledgedRewardCursor() {
    this.rewardService.acknowledgeRewardMechanism();
  }
}
